import React, { ChangeEvent, FC } from "react";

interface CheckboxProps {
  checkboxKey?: string;
  value?: string;
  onChange?: (target: string, value: boolean) => void;
  checked?: boolean;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
  additionalClasses?: string;
}

export const checkboxDefaultStyle =
  "inline-block mr-2 w-[18px] h-[18px] accent-CostcoAction-focus bg-gray-100 outline-2 outline-CostcoAction-focus shadow-sm shadow-gray/20";

const Checkbox: FC<CheckboxProps> = ({
  value,
  checkboxKey,
  onChange,
  checked,
  readOnly,
  disabled,
  placeholder,
  additionalClasses,
}) => {
  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newIsChecked = event.target.checked;
    const targetKey = event.target.id;
    onChange!(targetKey, newIsChecked);
  };
  return (
    <div className="flex absolute left-2 flex-row w-full">
      <input
        id={checkboxKey}
        defaultChecked={checked}
        onChange={handleCheckboxChange}
        type="checkbox"
        defaultValue={value}
        readOnly={readOnly}
        disabled={disabled}
        className={`hover:border-4 ${checkboxDefaultStyle} ${
          additionalClasses ?? ""
        }`}
        placeholder={placeholder}
      />
      <label
        htmlFor={checkboxKey}
        className="w-full ms-2 inline-block mt-[-3px] text-gray-900"
      >
        {value}
      </label>
    </div>
  );
};

export default Checkbox;
